import httpClient from './httpClient';
const prefix = 'bookingStatusText'

export default {
    async get_all (query) {
        const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/getBookingStatusTextAll`)
        return data
      },
}